import { DesktopDateTimePicker, DesktopDateTimePickerProps } from '@mui/x-date-pickers';

export interface CustomDateTimePickerProps<TDate extends Date> extends DesktopDateTimePickerProps<TDate> {}

export function CustomDateTimePicker<TDate extends Date>(props: CustomDateTimePickerProps<TDate>) {
  return <DesktopDateTimePicker {...props} />;
}
